import { render } from "./easyLightbox.vue?vue&type=template&id=d9edca2a"
import script from "./easyLightbox.vue?vue&type=script&lang=js"
export * from "./easyLightbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__